/**
 * Modulo que se encarga de configurar la internacionalización
 */
export default angular.module('spa.i18n', [
  'ui'
])
  .config(config)
  .name;

config.$inject = ['$translatePartialLoaderProvider', '$translateProvider'];

function config($translatePartialLoaderProvider, $translateProvider) {
  $translatePartialLoaderProvider.addPart('common');
  $translateProvider.useLoader('$translatePartialLoader', {
    urlTemplate: 'i18n/{part}/{lang}.json'
  });
  $translateProvider.useSanitizeValueStrategy('escape');
  $translateProvider.preferredLanguage('es');
  $translateProvider.translationNotFoundIndicator('$$$');
}


// WEBPACK FOOTER //
// ./src/core/i18n/index.js